import { BaseIcon as _BaseIcon } from '@carnica/graphics';
import PropTypes from 'prop-types';

import { enhancedConnect } from 'utils/lowCodeHelpers';

export const BaseIcon = enhancedConnect({
  iconClassName: PropTypes.string,
  name: PropTypes.string,
  color: PropTypes.oneOf([
    'disabled',
    'disabled-invert',
    'error',
    'link',
    'primary',
    'primary-invert',
    'secondary',
    'secondary-invert',
    'success',
    'tertiary',
    'tertiary-invert',
    'white',
    'black',
    'brand-primary',
    'brand-secondary',
    'brand-tertiary',
  ]),
  size: PropTypes.oneOf(['xs', 's', 'm', 'l']),
})(_BaseIcon);
